// extracted by mini-css-extract-plugin
module.exports = {"home":"afB1h0Lx","box":"_1OAZePNJ","logo":"_1fZ3OZ-j","title":"_3i9hJO9e","form-actions":"_2NxaxBaT"};